import { render, staticRenderFns } from "./SysInfo.vue?vue&type=template&id=60f9cf12&scoped=true&"
import script from "./SysInfo.vue?vue&type=script&lang=ts&"
export * from "./SysInfo.vue?vue&type=script&lang=ts&"
import style0 from "./SysInfo.vue?vue&type=style&index=0&id=60f9cf12&scoped=true&lang=scss&"
import style1 from "./SysInfo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f9cf12",
  null
  
)

export default component.exports